import { Plus } from 'lucide-react';
import { SiteLayout } from '../../components/site/SiteLayout';
import { PillLink, PillButton } from '../../components/site/Pill';
import { openSiteChat } from '../../components/SiteChat';
import { FAQS } from '../../lib/site';

export default function SiteFaqs() {
  return (
    <SiteLayout>
      <section className="site-narrow pt-20 lg:pt-32">
        <p className="eyebrow">Help</p>
        <h1 className="display mt-4 text-[44px] text-ink-900 sm:text-[60px] lg:text-[80px]">Frequently <em>asked</em> questions</h1>
        <p className="mt-6 max-w-xl text-[16px] leading-relaxed text-ink-500">Can't find it here? Our assistant knows every home, every policy and every date — ask it anything.</p>
        <PillButton onClick={openSiteChat} variant="ghost" className="mt-8">Ask the assistant</PillButton>
      </section>

      <section className="site-narrow py-20 lg:py-28">
        <div className="divide-y divide-ink-200 border-y border-ink-200">
          {FAQS.map(([q, a]) => (
            <details key={q} className="group py-6">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-6 text-left [&::-webkit-details-marker]:hidden">
                <span className="display text-[24px] text-ink-900 sm:text-[28px]">{q}</span>
                <Plus className="h-5 w-5 shrink-0 text-bronze-500 transition-transform duration-300 group-open:rotate-45" />
              </summary>
              <p className="mt-4 max-w-3xl text-[15px] leading-[1.8] text-ink-600">{a}</p>
            </details>
          ))}
        </div>
      </section>

      <section className="site-narrow pb-24 text-center lg:pb-36">
        <h2 className="display mx-auto max-w-[760px] text-[36px] text-ink-900 sm:text-[48px]">Ready to see what's <em>available</em>?</h2>
        <PillLink to="/rent" className="mt-8">Find your new home</PillLink>
      </section>
    </SiteLayout>
  );
}
